export default {

    items: {
        data: []
    }

}